import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC_gKOPOctuzkEVu0gHnvjBz6JBCEqwmdY",
  authDomain: "investorverden-dk.firebaseapp.com",
  projectId: "investorverden-dk",
  storageBucket: "investorverden-dk.firebasestorage.app",
  messagingSenderId: "584090243136",
  appId: "1:584090243136:web:8895633172a21f8ac20fa5",
  measurementId: "G-1FCHJRFN4D"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const db = firestore; // Add alias

export { auth, firestore, db }; // Export both names